import { render, staticRenderFns } from "./businessDetails.vue?vue&type=template&id=16cd6f51&scoped=true"
import script from "./businessDetails.vue?vue&type=script&lang=js"
export * from "./businessDetails.vue?vue&type=script&lang=js"
import style0 from "./businessDetails.vue?vue&type=style&index=0&id=16cd6f51&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cd6f51",
  null
  
)

export default component.exports